import { Container, EmptyState, Section } from '@/components/common';
import { routes } from '@/config/routes';
import { useDocumentMetadata } from '@/hooks/useDocumentMetadata';

export function ProductNotFoundPage({ categoryOnly = false }: { categoryOnly?: boolean }) {
  useDocumentMetadata(categoryOnly ? 'Category Not Found' : 'Product Not Found');
  return (
    <Section spacing="large">
      <Container size="narrow">
        <EmptyState
          icon="pi pi-box"
          title={categoryOnly ? 'Category not found' : 'Product unavailable'}
          description={
            categoryOnly
              ? 'That product category is not part of the current Emazy collection.'
              : 'This product may have moved or is not available in the current demonstration catalog.'
          }
          actionLabel="Browse all products"
          actionTo={routes.products}
        />
      </Container>
    </Section>
  );
}
